/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsShapeLink: {
  name: 'shape-link';
  data: string;
} = {
  name: 'shape-link',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M4 3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H4Zm1 6V5h4v4H5Zm-2 5a1 1 0 0 1 1-1h5.586L13 9.586V4a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1h-5.586L11 14.414V20a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-6Zm2 1v4h4v-4H5Zm8 5v-6a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1h-6a1 1 0 0 1-1-1Zm2-5v4h4v-4h-4Zm0-10v4h4V5h-4Z" fill="currentColor"/></svg>`,
};
